import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { Col, Row } from "react-bootstrap";
import { NFLookupContract } from "src/components/Shared/NewForms/NFLookupContract";
import { NFLookupVendor } from "src/components/Shared/NewForms/NFLookupVendor";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

export const ImportsDetailMain = () => {
    const { t } = useTranslation();
    const { watch } = useFormContext();
    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("Document#")}
                        disabled
                        fieldName={"documentNumber"}
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={t("DocumentDate")}
                        fieldName={"documentDate"}
                        required={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupCompany
                        fieldName={"companyId"}
                        title={t("Company")}
                        required={true}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupDivision
                    companyId={watch('companyId')}
                        fieldName={"divisionId"}
                        title={t("Division")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupVendor
                        fieldName={"vendorId"}
                        title={t("Vendor")}
                        required={true}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupContract
                        fieldName={"contractId"}
                        title={t("Contract")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupWarehouse
                        fieldName={"warehouseId"}
                        title={t("Warehouse")}
                        companyId={watch('companyId')}
                    />
                </Col>
            </Row>
        </>
    );
};
